import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataInvestorProfile } from '@onefootprint/request-types/dashboard';
import type { NodeProps } from '@/playbook-builder/playbook-builder.types';
import BaseNode from '../base-node';
import InvestorProfileSection from '../investor-profile-section';
export const InvestorProfileNode = node => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      form: "investor-profile",
      render: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== node.data || $[2] !== node.id) {
    t1 = <BaseNode nodeId={node.id} data={node.data} sidebar={t0} />;
    $[1] = node.data;
    $[2] = node.id;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default InvestorProfileNode;
function _temp() {
  return <InvestorProfileSection />;
}